module.exports = __webpack_public_path__ + "media/images/area/sub_hero_map_gunma-d7bbbf8e90d6fef8597f950007e0b927.png";